import { Container } from '@mui/material';
import OrganizationDetail from 'components/templates/OrganizationDetail';
import React from 'react';
import { useParams } from 'react-router-dom';

export const OrganizationDetailView = () => {
  const { orgId: id } = useParams();
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <OrganizationDetail id={id !== undefined ? Number(id) : 0} />
    </Container>
  );
};
